import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";
import { useTenant } from "../../contexts/TenantContext.tsx";
import SectionCard from "../SectionCard.tsx";

/** "Method: org_number · Confidence: 92%", or null when neither is known. */
export function matchSummary(
  method: string | null,
  confidence: number | null,
  methodLabel = "Method",
): string | null {
  const parts: string[] = [];
  if (method) parts.push(`${methodLabel}: ${method}`);
  if (confidence != null) parts.push(`Confidence: ${(confidence * 100).toFixed(0)}%`);
  return parts.length > 0 ? parts.join(" · ") : null;
}

interface MatchedCompanyCardProps {
  companyId: string;
  name: string;
  method: string | null;
  confidence: number | null;
}

/** The master company a record was matched to, and how. */
export default function MatchedCompanyCard({ companyId, name, method, confidence }: MatchedCompanyCardProps) {
  const { tenantPath } = useTenant();
  const summary = matchSummary(method, confidence);
  return (
    <SectionCard title="Matched Company">
      <Link component={RouterLink} to={tenantPath(`/companies/${companyId}`)} underline="hover">
        {name}
      </Link>
      {summary && (
        <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
          {summary}
        </Typography>
      )}
    </SectionCard>
  );
}
